import styled from "styled-components";
import { typography } from "@streeteasy/design-system";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";

export const ConfirmationContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const Icon = styled(FontAwesomeIcon).attrs({
  color: "primary",
  desktopPadding: "2px 0",
  fontSize: "30px",
  iconClass: "check",
  mobilePadding: "2px 0"
})`
  margin-bottom: 8px;
`;

export const Title = styled(typography.PrimarySmall)``;

export const Text = styled(typography.Body)`
  margin-top: 16px;
`;
